module.exports = __webpack_public_path__ + "img/edu-institution-2.238036c9.png";